import { ReactElement } from "react";
import { Tooltip, TooltipPopup, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ICON_SIZE, SIZE } from "@/configs/sizes";
import { ICON_KEY, type IconComponent, iconRegistry } from "@/icons";
import { cn } from "@/utils/class-name";

interface IconProps {
    label?: string;
    tooltip?: string;
    labelClassName?: string;
    tooltipClassName?: string;
    iconClassName?: string;
    size?: SIZE;
    renderAs?: ReactElement; // Escape hatch to avoid rendering component as "button"
    icon: ICON_KEY | IconComponent;
    ariaHidden?: boolean;
}

export function Icon({
    icon,
    label,
    tooltip,
    labelClassName,
    tooltipClassName,
    iconClassName,
    size = SIZE.BASE,
    renderAs = undefined,
    ariaHidden = false,
}: IconProps) {
    const IconComponent = typeof icon === "string" ? iconRegistry[icon] : icon;
    return (
        <>
            {tooltip ? (
                <TooltipProvider delay={150}>
                    <Tooltip disabled={!tooltip}>
                        <TooltipTrigger render={renderAs ?? undefined}>
                            <div className={"flex flex-col items-center gap-1"}>
                                <IconComponent
                                    aria-hidden={ariaHidden}
                                    className={cn(`${ICON_SIZE[size].className}`, iconClassName)}
                                />
                                {label && <p className={cn(`text-base`, labelClassName)}>{label}</p>}
                            </div>
                        </TooltipTrigger>
                        <TooltipPopup className={cn(tooltipClassName)}>{tooltip}</TooltipPopup>
                    </Tooltip>
                </TooltipProvider>
            ) : (
                <div className={"flex flex-col items-center gap-1"}>
                    <IconComponent
                        aria-hidden={ariaHidden}
                        className={cn(`${ICON_SIZE[size].className}`, iconClassName)}
                    />
                    {label && <p className={cn(`text-base`, labelClassName)}>{label}</p>}
                </div>
            )}
        </>
    );
}
